/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notification_Preference_Minute_RequiredInputs */

const en_us2_notification_preference_minute_required = /** @type {(inputs: Notification_Preference_Minute_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a time for the reminder.`)
};

const pt_br2_notification_preference_minute_required = /** @type {(inputs: Notification_Preference_Minute_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um horário para o lembrete.`)
};

const es_419_notification_preference_minute_required = /** @type {(inputs: Notification_Preference_Minute_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige una hora para el recordatorio.`)
};

const pt_pt2_notification_preference_minute_required = /** @type {(inputs: Notification_Preference_Minute_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe uma hora para o lembrete.`)
};

const fr_fr2_notification_preference_minute_required = /** @type {(inputs: Notification_Preference_Minute_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis une heure pour le rappel.`)
};

const de_de2_notification_preference_minute_required = /** @type {(inputs: Notification_Preference_Minute_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl eine Uhrzeit für die Erinnerung.`)
};

const it_it2_notification_preference_minute_required = /** @type {(inputs: Notification_Preference_Minute_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un orario per il promemoria.`)
};

/**
* | output |
* | --- |
* | "Choose a time for the reminder." |
*
* @param {Notification_Preference_Minute_RequiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const notification_preference_minute_required = /** @type {((inputs?: Notification_Preference_Minute_RequiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Preference_Minute_RequiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_notification_preference_minute_required(inputs)
	if (locale === "es-419") return es_419_notification_preference_minute_required(inputs)
	if (locale === "pt-PT") return pt_pt2_notification_preference_minute_required(inputs)
	if (locale === "fr-FR") return fr_fr2_notification_preference_minute_required(inputs)
	if (locale === "de-DE") return de_de2_notification_preference_minute_required(inputs)
	if (locale === "it-IT") return it_it2_notification_preference_minute_required(inputs)
	return en_us2_notification_preference_minute_required(inputs)
});
export { notification_preference_minute_required as "notification_preference.minute_required" }